<template>
    <div class="min-h-screen bg-gray-100">
        <header class="bg-white border-b border-gray-100">
            <nav class="flex flex-row p-3 container mx-auto">
                <SvgVue icon="kuka" class="flex-none h-8 w-32 mr-4" />
                <div class="grow text-lg text-gray-600 lg:flex" :class="{ hidden: hideMenu }">
                    <Link :href="route('manager.event.create')" class="no-underline block mt-4 lg:inline-block lg:mt-0 mr-4" @click="hideMenu=true">Neue Veranstaltung eingeben</Link>
                    <Link :href="route('manager.index')" class="no-underline block mt-4 lg:inline-block lg:mt-0 mr-4" @click="hideMenu=true">Meine Veranstaltungen</Link>
                    <Link :href="route('manager.data.show')" class="no-underline block mt-4 lg:inline-block lg:mt-0 mr-4" @click="hideMenu=true">Meine Daten</Link>
                </div>
                <div v-if="auth" class="flex-none flex items-end">
                    <div class="mr-5 lg:mr-0">
                        <span>Angemeldet als <strong>{{ auth }}</strong></span>&nbsp;
                        <Link as="button"
                              :href="route('manager.logout')"
                              method="post"
                              class="px-4 py-2 bg-blue-500 hover:bg-blue-700 rounded-md font-semibold text-white text-xs"
                        >Abmelden</Link>
                    </div>
                    <div class="block lg:hidden">
                        <button class="flex items-center px-4 py-2 border rounded text-blue-500 border-blue-500 focus:outline-none" @click="hideMenu = !hideMenu">
                            <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <title>Menü</title>
                                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </nav>
        </header>
        <main class="mt-6">
            <section class="container mx-auto px-3">
                <slot />
            </section>
        </main>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import {ref} from "vue";
const props = defineProps({
    auth: String
})
const hideMenu = ref(true);
</script>
